import { ColorModeContext, useMode } from "./theme";
import { useState } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Routes, Route } from "react-router-dom";

import Sidebar from "./scenes/global/Sidebar";
import Dashboard from "./scenes/dashboard";
import TablaParticipantes from "./scenes/participantes";
import Regiones from "./scenes/regiones";
import Universidades from "./scenes/universidades";
import ActividadesAnuales from "./scenes/actividadesAnuales";
import Formacion from "./scenes/formacion";
import Historial from "./scenes/user";

import { AuthProvider, useAuth } from "./AuthContext";
import { DisciplineProvider } from "./DisciplineContext";
import { DataProvider } from "./DataContext";
import { CountryProvider } from "./CountryContext";
import { LoginModalProvider } from "./components/LoginModalController";
import ProtectedRoute from "./components/ProtectedRoute";
import StagingBanner from "./components/StagingBanner";

const isStaging = process.env.REACT_APP_ENV === "staging";

function AppShell({ theme, colorMode }) {
  const { isAuthenticated } = useAuth();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {isStaging && <StagingBanner />}

        <div className="app">
          {/* opcional: ocultar sidebar si no hay sesión */}
          <div
            style={{
              pointerEvents: isAuthenticated ? "auto" : "none",
              opacity: isAuthenticated ? 1 : 0.55,
              filter: isAuthenticated ? "none" : "grayscale(0.2)",
            }}
          >
            {<Sidebar />}
          </div>
          


          <main className="content">
            <Routes>
              <Route path="/" element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="/participantes" element={
                  <ProtectedRoute allowedRoles={["admin", "staff"]}>
                    <TablaParticipantes />
                  </ProtectedRoute>
                }
              />
              <Route path="/regiones" element={
                  <ProtectedRoute>
                    <Regiones />
                  </ProtectedRoute>
                }
              />
              <Route path="/universidades" element={
                  <ProtectedRoute>
                    <Universidades />
                  </ProtectedRoute>
                }
              />
              <Route path="/actividades" element={
                  <ProtectedRoute>
                    <ActividadesAnuales />
                  </ProtectedRoute>
                }
              />
              <Route path="/formacion" element={
                  <ProtectedRoute>
                    <Formacion />
                  </ProtectedRoute>
                }
              />

              <Route path="/historial" element={
                  <ProtectedRoute>
                    <Historial />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default function App() {
  const [fontScale] = useState(1);
  const [theme, colorMode] = useMode(fontScale);

  return (
<AuthProvider>
  <LoginModalProvider>
    <DataProvider>
      <CountryProvider>
      <DisciplineProvider>
          <AppShell theme={theme} colorMode={colorMode} />
      </DisciplineProvider>
      </CountryProvider>
    </DataProvider>
  </LoginModalProvider>
</AuthProvider>
  );
}
